define(['basemodel'], (BaseModel) => BaseModel.extend({
    url: '/auth',

    isNew () {
        return false;
    },

    defaults: {
        email: null,
        password: null,
        remember: null,
        ttl: null
    }
}));
